export default {
  methods: {

    draw_Table() {

      let tableGroup = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.table.y})`)

      let y_ = 0
      this.table.box.forEach(box=> {

        let tbl = tableGroup
        .append('g')
        .attr('transform', `translate(${this.table.padding}, ${y_})`)

        tbl
        .append('text')
        .attr('x', 0).attr('y', -3)
        .attr('fill', box.tColor).attr('font-size', box.tSize)
        .text(box.name)

        tbl
        .append('rect')
        .attr('x', 0).attr('y', 0).attr('rx', this.table.radius)
        .attr('width', this.table.width).attr('height', this.table.height)
        .attr('fill', box.color).attr('opacity', box.opacity)
        
        y_ += this.table.height + this.table.margin

        this.draw_Items(tbl, box)
      })
    },


    draw_Items(tbl, box) {

      let item = tbl
      .append('g')
      .attr('transform', `translate(${this.table.padding}, ${this.table.padding})`)

      let by = 0
      this.columns.forEach(d=> {
        item
        .append('text')
        .attr('x', d.tx).attr('y', by + this.table.header.tSize*0.75)
        .attr('fill', this.table.header.tColor).attr('font-size', this.table.header.tSize)
        .attr('text-anchor', d.align)
        .text(d.name)
      }) 

      by += this.table.lineheight

      this.rawData.filter(f=> f.PHASE == box.phase).forEach(d=> {

        this.columns.forEach(col=> {
          item
          .append('text')
          .attr('x', col.tx).attr('y', by + (col.tSize ? col.tSize*0.75 : this.table.value.tSize*0.75))
          .attr('fill', col.tColor ? col.tColor : this.table.value.tColor)
          .attr('font-size', col.tSize ? col.tSize : this.table.value.tSize)
          .attr('text-anchor', col.align)
          .text(d[col.code])
          .call(this.event_Link, col, d)
        }) 
        by += this.table.lineheight
      })

    }
  } 
}